<template>
  <div class="frame3">
    <div class="frame3_top">
      APP专享功能
      <img
        src="../../../../public/img/shares_Info/close.png"
        alt=""
      />
    </div>
    <div class="frame3_content">
      <img src="../../../../public/img/shares_Info/erweima1.png" alt="" />
      <div class="frame3_content_text">扫码下载小钱书APP查看详情</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.frame3 {
  width: 300px;
  height: 283px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  position: fixed;
  top: calc(50% - 121px);
  left: calc(50% - 190px);
  z-index: 9999999;
  padding: 30px 38px 30px 40px;
}
.frame3_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame3_top img {
  width: 19px;
  float: right;
  margin-top: 0px;
}
.frame3_content{
    text-align: center;
    margin-top: 37px;
}
.frame3_content img{
    width: 148px;
    height: 148px;
    margin-bottom: 12px;
}
</style>